import React from 'react';
import { Snackbar } from '@mui/material';
import { MarketToast } from '@market/react';

const Toast = (props) => {
  const {
    horizontal = 'right',
    vertical = 'top',
    timeout,
    open = false,
    message = '',
    variant = 'info',
    action,
    onClose,
  } = props;

  return (
    <Snackbar
      anchorOrigin={{ horizontal, vertical }}
      autoHideDuration={timeout}
      onClose={onClose}
      open={open}
    >
      <MarketToast variant={variant} onMarketToastManuallyDismissed={onClose}>
        <p>{message}</p>
        {action && React.cloneElement(action, { slot: 'action' })}
      </MarketToast>
    </Snackbar>
  );
};

export default Toast;
